import React, { useEffect } from "react";
import Images from "../../assets/images/index";
import Icons from "../../assets/icons/index";
import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import { Get_Mantra_Topic, jump_mantra } from "../../gql/queries";
import { Link, NavLink, useLocation, useNavigate, useParams } from "react-router-dom";
import { useState } from "react";
import { GET_Bookmarked_Video, Report_Submit } from "../../gql/mutation";
import Modal from "react-bootstrap/Modal";
import { toast, ToastContainer } from "react-toastify";
import { firebaseData } from "../../firebase";
import { authorizationCheck } from "../../utils/logout";
import { decrypt } from "../../utils/crypto";
import { GET_Instrucation_QB } from "../../gql/queries";

import Loader from "../common/Loader/Loader";

export default function MantraContent() {
	let { index, id, text, subindex } = useParams();
	const navigate = useNavigate()
	const [config, setConfig] = useState();
	const location = useLocation();
	const [remoteLoading, setRemoteLoading] = useState(true);
	const [pearlData, setPearl] = useState(JSON.parse(location.state));
	const [course, setCourse] = useState(JSON.parse(decrypt(localStorage.getItem('profileDetails'))));
	const [infoShow, setInfo] = useState(false);
	const infoDetailhide = () => setInfo(false);
	const [indexId, indexData] = useState(parseInt(index));
	const [indx, setIndex] = useState(parseInt(location.state));
	const [report] = useMutation(Report_Submit)
	const [trigger, setTrigger] = useState(0)
	const [enable, setDisabled] = useState(true)
	// console.log(indx,"jjjjjjjjjj")
	const INITIAL_STATE = {
		contentType: "",
		userFeedBack: "",
		category: "",
		contentId: ''
	};
	const [getDetails, Details] = useState(INITIAL_STATE);
	const handleInputChange = function (fieldValue, fieldName) {
		getDetails.contentType = "Pearl"
		Details({ ...getDetails, [fieldName]: fieldValue })
		if (!fieldValue) {
			setDisabled(true)
		} else {
			setDisabled(false)
		}
	}
	var [getall, { loading, error, data }] = useLazyQuery(jump_mantra, {
		variables: {
			"pearlCode": id,
		},
	});
	const infoDetailShow = () => setInfo(true);
	const alldata = () => {
		if (text === 'jump') {
			getall()
		}
	}

	const changeIndex = () => {
		indexData(0)
	}

	useEffect(() => {
		if (text === 'jump') {
			alldata()
		}
		const getConfigData = async () => {
			try {
				const remoteData = await firebaseData('report_config'); // Replace 'your_config_key' with the actual key for the configuration value you want
				setConfig(JSON.parse(remoteData));
				setRemoteLoading(false);
			} catch (error) {
				console.error('Error fetching remote data:', error);
				setRemoteLoading(false);
			}
		};

		if (typeof window !== 'undefined') {
			getConfigData();
		}
	}, [])
	const nextMantra = (index) => {
		if (index < query2?.data?.layer?.subLayers[subindex].subContents.length - 1) {
			let nextIndex = index + 1
			indexData(nextIndex);
		}
	}

	const prevMantra = () => {
		if (query2?.data?.layer?.subLayers[subindex].subContents.length > 0) {
			if (indexId !== 0) {
				indexData(indexId - 1)
			}
		}
	}
	const query1 = useQuery(GET_Instrucation_QB, {
		variables: {
			"_id": id,
		},
	});
	const query2 = useQuery(Get_Mantra_Topic, {
		variables: {
			"_id": id,
			"language": "English",
			"contentType": "pearl"
		},
	});

	// const setSubLayers = (setData) => {
	// 		setPearl(setData)
	// }
	// if (!query2.loading) {
	// 	setSubLayers(query2.data.layer.subLayers[subindex])
	// }

	const [getJumpBookmark] = useMutation(GET_Bookmarked_Video, {
		refetchQueries: [
			{
				query: jump_mantra, variables: {
					"pearlCode": id,
				},
			}, // DocumentNode object parsed with gql
			'pearlByCode' // Query name,

		]
	})
	const [getBookmark] = useMutation(GET_Bookmarked_Video, {
		refetchQueries: [
			{
				query: Get_Mantra_Topic, variables: {
					"_id": id,
					"language": "English",
					"contentType": "pearl"
				}
			}, // DocumentNode object parsed with gql
			'videolayer' // Query name,

		]
	});

	const handleSubmit = async (e) => {
		e.preventDefault();
		getDetails.contentId = query1.data && query1.data.qb.questions[indx]._id
		getDetails.courseName = course?.preparingFor || ""
		report({ variables: { addReportInput: getDetails } }).then(res => {
			if (res.data.addUserReport.userId) {
				Details(INITIAL_STATE)
				setInfo(false)
				toast.success('Report Successful Submitted')
			}
		}).catch(res => {
			const errors = res.graphQLErrors.map(err => err.message);
			console.log(errors)
		})
	}
	if (query2.loading) return (<><Loader /></>)
	// console.log(query2.data?.layer?.subLayers,"query2.data?.layer?.subLayers")

	return (
		<>
			{
				text === 'mantra' &&
				<div className="main_wrapper">
					<div className="breadcrumbs">
						<ul className="breadcrumb">
							<li className="breadcrumb-item"><a>Home</a></li>
							<li className="breadcrumb-item"><a>Mantras</a></li>
							<li className="breadcrumb-item"><a>Anatomy Mantras</a></li>
							<li className="breadcrumb-item active"><a>Muscles Of Mastication & Their Actions</a></li>
						</ul>
					</div>
					{
						<section className="videoLayer_wrapper mantraList_wrapper section_side_padding">
							<div className='row'>
								<div className="col-lg-8 col-md-7 col-sm-12">
									<div className="topics_wrapper_main">
										<div className="subjects_wrapper topic_header">
											<div className="topic_image_ttl d-flex align-items-baseline">
												<figure className="back_arrow">
													<Link to={`/mantras/mantraslisting/${id}`}>
														<img src={Icons.BackArrow} alt="Back Arrow" className="img-fluid" />
													</Link>
												</figure>
												<div className="subject_ttl_detail">
													<h5>{!query2.loading && query2.data?.layer?.subLayers[subindex]?.subContents[indexId]?.pearl.title}</h5>
													<span className="totl_numbr"><span className="num_count">No.</span> {!query2.loading && query2.data.layer.subLayers[subindex].subContents[indexId]?.pearl.pearlsCode}</span>
													<p>
														{
															query2.data?.layer?.subLayers[subindex]?.subContents[indexId]?.pearl?.subjectDetail?.topicName !== null &&
															<span>{!query2.loading && query2.data?.layer?.subLayers[subindex]?.subContents[indexId]?.pearl?.subjectDetail?.topicName}</span>
														}
														<span>{!query2.loading && query2.data?.layer?.subLayers[subindex]?.subContents[indexId]?.pearl?.subjectDetail?.subjectName}</span>
													</p>
												</div>
											</div>
										</div>

										<div className="recommended_video_wrapper">
											<div className="mantra_body_content">
												<div className="mantra_hedr d-flex align-items-center">
													<div className="mantra_ttl">
														<h6>Mantra</h6>
													</div>
													<div className="mantra_share_options">
														{/* <img src={Icons.ShareBlue} alt="" className="img-fluid"/> */}
														<img src={Icons.Info} alt="" onClick={infoDetailShow} className="img-fluid" />
														{
															!query2.loading && query2.data?.layer?.subLayers[subindex]?.subContents[indexId]?.pearl?.progress?.isBookMarked === false &&
															<img src={Icons.Bookmark} alt="" className="img-fluid" onClick={() => getBookmark({
																variables: {
																	contentType: "Pearl", "topicId": !query2.loading && query2.data.layer.subLayers[subindex].subContents[indexId]?.pearl.subjectDetail.topicId, "subjectId": !query2.loading && query2.data.layer.subLayers[subindex].subContents[indexId]?.pearl.subjectDetail.subjectId, "contentId": !query2.loading && query2.data.layer.subLayers[subindex].subContents[indexId]?.pearl._id, "isCompleted": false, "courseName": "NEET PG Program", "isBookMarked": true
																}
															})} />
														}

														{
															!query2.loading && query2.data?.layer?.subLayers[subindex]?.subContents[indexId]?.pearl?.progress?.isBookMarked === true &&
															<img src={Icons.unBookmark} alt="" className="img-fluid" onClick={() => getBookmark({
																variables: {
																	contentType: "Pearl", "topicId": !query2.loading && query2.data.layer.subLayers[subindex].subContents[indexId]?.pearl.subjectDetail.topicId, "subjectId": !query2.loading && query2.data.layer.subLayers[subindex].subContents[indexId]?.pearl.subjectDetail.subjectId, "contentId": !query2.loading && query2.data.layer.subLayers[subindex].subContents[indexId]?.pearl._id, "isCompleted": false, "courseName": "NEET PG Program", "isBookMarked": false
																}
															})} />
														}
														{
															!query2.loading && query2.data?.layer?.subLayers[subindex]?.subContents[indexId]?.pearl?.progress == null || !query2.loading && query2.data?.layer?.subLayers[subindex]?.subContents[indexId]?.pearl?.progress?.isBookMarked === null &&
															<img src={Icons.Bookmark} alt="" className="img-fluid" onClick={() => getBookmark({
																variables: {
																	contentType: "Pearl", "topicId": !query2.loading && query2.data.layer.subLayers[subindex].subContents[indexId]?.pearl.subjectDetail.topicId, "subjectId": !query2.loading && query2.data.layer.subLayers[subindex].subContents[indexId]?.pearl.subjectDetail.subjectId, "contentId": !query2.loading && query2.data.layer.subLayers[subindex].subContents[indexId]?.pearl._id, "isCompleted": false, "courseName": "NEET PG Program", "isBookMarked": true
																}
															})} />
														}
													</div>
												</div>
												<div className="mantra_text">
													<div className="mantra_child">
														<div className="table-responsive" dangerouslySetInnerHTML={{ __html: !query2.loading && `${query2.data.layer.subLayers[subindex] ? query2.data.layer.subLayers[subindex].subContents[indexId]?.pearl.description : ""}` }}></div>
													</div>
													{/* <ul type="none" className="mantra_child">
                                            <li>Moments- Muscles Involved</li>
                                            <li>Velevation- Medial Pterygoid Of Mandible Masseter Temporails</li>
                                            <li>Vdepression Of Mandible- Lateral Pterygoid(Mainly), Digastric, Geniohyoid, Mylohyoid</li>
                                            <li>Vretraction Of Jaw- Temporails</li>
                                            <li>Vprotrusion Of Jaw- Lateral Pterygoid(Mainly), Medial Pterygoid, Masseter.</li>
                                        </ul> */}
												</div>
											</div>
										</div>
										<div className="mantra_btns d-flex align-items-center justify-content-between">
											{
												indexId > 0 &&
												<button type="button" className="btn btn_theme btn_border" onClick={prevMantra}>Previous</button>
											}
											{
												indexId === 0 &&
												<button type="button" className="btn btn_theme btn_border" disabled>Previous</button>
											}
											{
												indexId < query2?.data?.layer?.subLayers[subindex].subContents.length - 1 &&
												<button type="button" className="btn btn_theme" onClick={() => nextMantra(indexId)}>Next</button>
											}
											{
												query2?.data?.layer?.subLayers[subindex].subContents.length - 1 === indexId &&
												<button type="button" className="btn btn_theme" disabled>Next</button>
											}
										</div>
									</div>
								</div>
								<div className="col-lg-4 col-md-4 col-sm-12">
									<div className="subjects_wrapper Subject_selection_right_side">
										<div className="subjects_header">
											<h6>Move to other Topic</h6>
										</div>
										<div className="all_subjects_name_wrapper">
											<ul type="none" className="subjects_child d-flex flex-wrap">
												{
													query2?.data && query2?.data?.layer?.subLayers?.map((d, idx) => (
														<li>
															<NavLink to={d.subContents ? `/mantras/mantrascontent/${0}/${id}/mantra/${idx}` : '#'} onClick={changeIndex}>
																<div className="subject_main_list d-flex align-itmes-center">
																	<div className="subject_img_wrap d-flex align-items-center">
																		<figure className="subject_img">
																			<img src={d.icon ? d.icon : Images.defaultImg} alt="" className="img-fluid" />
																		</figure>
																		<div className="subject_details">
																			<h6>{d.title}</h6>
																		</div>
																	</div>
																</div>
															</NavLink>
														</li>
													))
												}
											</ul>
										</div>
									</div>
								</div>

								{/* <div className="col-lg-4 col-md-4 col-sm-12">
						<div className="subjects_wrapper Subject_selection_right_side">
							<div className="subjects_header">
                                <h6>Move to other Topic</h6>
                            </div>
							<div className="all_subjects_name_wrapper">
								<ul type="none" className="subjects_child d-flex flex-wrap">
									{
										query1.data.layer.subLayers.map(d=>
											<li>
												<NavLink to ={`/mantras/mantrascontent/${d._id}`}>
													<div className="subject_main_list d-flex align-itmes-center">
														<div className="subject_img_wrap d-flex align-items-center">
															<figure className="subject_img">
																<img src={d.icon} alt="" className="img-fluid" />
															</figure>
															<div className="subject_details">
																<h6>{d.title}</h6>
																<p>{d.author?d.author:''}</p>
															</div>
														</div>	
													</div>
												</NavLink>
											</li>
										)
									}
									<li>
										<a href="javascript:;">
											<div className="subject_main_list d-flex align-itmes-center">
												<div className="subject_img_wrap d-flex align-items-center">
													<figure className="subject_img">
														<img src={Icons.Micro} alt="" className="img-fluid" />
													</figure>
													<div className="subject_details">
														<h6>Forensic Medicine</h6>
														<p>Dr.Ashwani Kumar</p>
													</div>
												</div>	
											</div>
										</a>
									</li>
									<li>
										<a href="javascript:;">
											<div className="subject_main_list d-flex align-itmes-center">
												<div className="subject_img_wrap d-flex align-items-center">
													<figure className="subject_img">
														<img src={Icons.Micro} alt="" className="img-fluid" />
													</figure>
													<div className="subject_details">
														<h6>Physiology</h6>
														<p>Dr.Ashwani Kumar</p>
													</div>
												</div>	
											</div>
										</a>
									</li>
									<li>
										<a href="javascript:;">
											<div className="subject_main_list d-flex align-itmes-center">
												<div className="subject_img_wrap d-flex align-items-center">
													<figure className="subject_img">
														<img src={Icons.Micro} alt="" className="img-fluid" />
													</figure>
													<div className="subject_details">
														<h6>Microbiology</h6>
														<p>Dr.Ashwani Kumar</p>
													</div>
												</div>	
											</div>
										</a>
									</li>
								</ul>
							</div>
						</div>
					</div> */}
							</div>

						</section>
					}
				</div>
			}
			{
				text === 'jump' &&
				<div className="main_wrapper">
					<div className="breadcrumbs">
						<ul className="breadcrumb">
							<li className="breadcrumb-item"><a>Home</a></li>
							<li className="breadcrumb-item"><a>Mantras</a></li>
							<li className="breadcrumb-item active"><a>{data && data.pearlByCode.title}</a></li>
						</ul>
					</div>
					{
						<section className="videoLayer_wrapper mantraList_wrapper section_side_padding">
							<div className='row'>
								<div className="col-lg-8 col-md-7 col-sm-12">
									<div className="topics_wrapper_main">
										<div className="subjects_wrapper topic_header">
											<div className="topic_image_ttl d-flex align-items-baseline">
												<figure className="back_arrow" onClick={() => navigate(-1)}>
													{/* <Link to={`/mantras/mantraslisting/${id}`}> */}
													<img src={Icons.BackArrow} alt="Back Arrow" className="img-fluid" />
													{/* </Link> */}
												</figure>
												<div className="subject_ttl_detail">
													<h5>{data && data.pearlByCode.title}</h5>
													<span className="totl_numbr"><span className="num_count">No.</span> {data && data.pearlByCode.pearlsCode}</span>
													<p>
														{
															data && data.pearlByCode?.subjectDetail?.topicName !== null &&
															<span>{data && data.pearlByCode.subjectDetail.topicName}</span>
														}
														<span>{data && data.pearlByCode.subjectDetail.subjectName}</span>
													</p>
												</div>
											</div>
										</div>

										<div className="recommended_video_wrapper">
											<div className="mantra_body_content">
												<div className="mantra_hedr d-flex align-items-center">
													<div className="mantra_ttl">
														<h6>Mantra</h6>
													</div>
													<div className="mantra_share_options">
														{/* <img src={Icons.ShareBlue} alt="" className="img-fluid"/> */}
														<img src={Icons.Info} alt="" onClick={infoDetailShow} className="img-fluid" />
														{
															data && data.pearlByCode.progress.isBookMarked === false &&
															<img src={Icons.Bookmark} alt="" className="img-fluid" onClick={() => getJumpBookmark({
																variables: {
																	contentType: "Pearl", "topicId": data && data.pearlByCode.subjectDetail.topicId, "subjectId": data && data.pearlByCode.subjectDetail.subjectId, "contentId": data && data.pearlByCode._id, "isCompleted": false, "courseName": "NEET PG Program", "isBookMarked": true
																}
															})} />
														}
														{
															data && data.pearlByCode.progress.isBookMarked === true &&
															<img src={Icons.unBookmark} alt="" className="img-fluid" onClick={() => getJumpBookmark({
																variables: {
																	contentType: "Pearl", "topicId": data && data.pearlByCode.subjectDetail.topicId, "subjectId": data && data.pearlByCode.subjectDetail.subjectId, "contentId": data && data.pearlByCode._id, "isCompleted": false, "courseName": "NEET PG Program", "isBookMarked": false
																}
															})} />
														}
														{
															data && data.pearlByCode.progress == null || data && data.pearlByCode.progress.isBookMarked === null &&
															<img src={Icons.Bookmark} alt="" className="img-fluid" onClick={() => getJumpBookmark({
																variables: {
																	contentType: "Pearl", "topicId": data && data.pearlByCode.subjectDetail.topicId, "subjectId": data && data.pearlByCode.subjectDetail.subjectId, "contentId": data && data.pearlByCode._id, "isCompleted": false, "courseName": "NEET PG Program", "isBookMarked": true
																}
															})} />
														}
													</div>
												</div>
												<div className="mantra_text">
													<div className="mantra_child">
														<div className="table-responsive" dangerouslySetInnerHTML={{ __html: `${data ? data && data.pearlByCode.description : ""}` }}></div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>

								{/* <div className="col-lg-4 col-md-4 col-sm-12">
						<div className="subjects_wrapper Subject_selection_right_side">
							<div className="subjects_header">
                                <h6>Move to other Topic</h6>
                            </div>
							<div className="all_subjects_name_wrapper">
								<ul type="none" className="subjects_child d-flex flex-wrap">
									{
										query1.data.layer.subLayers.map(d=>
											<li>
												<NavLink to ={`/mantras/mantrascontent/${d._id}`}>
													<div className="subject_main_list d-flex align-itmes-center">
														<div className="subject_img_wrap d-flex align-items-center">
															<figure className="subject_img">
																<img src={d.icon} alt="" className="img-fluid" />
															</figure>
															<div className="subject_details">
																<h6>{d.title}</h6>
																<p>{d.author?d.author:''}</p>
															</div>
														</div>	
													</div>
												</NavLink>
											</li>
										)
									}
									<li>
										<a href="javascript:;">
											<div className="subject_main_list d-flex align-itmes-center">
												<div className="subject_img_wrap d-flex align-items-center">
													<figure className="subject_img">
														<img src={Icons.Micro} alt="" className="img-fluid" />
													</figure>
													<div className="subject_details">
														<h6>Forensic Medicine</h6>
														<p>Dr.Ashwani Kumar</p>
													</div>
												</div>	
											</div>
										</a>
									</li>
									<li>
										<a href="javascript:;">
											<div className="subject_main_list d-flex align-itmes-center">
												<div className="subject_img_wrap d-flex align-items-center">
													<figure className="subject_img">
														<img src={Icons.Micro} alt="" className="img-fluid" />
													</figure>
													<div className="subject_details">
														<h6>Physiology</h6>
														<p>Dr.Ashwani Kumar</p>
													</div>
												</div>	
											</div>
										</a>
									</li>
									<li>
										<a href="javascript:;">
											<div className="subject_main_list d-flex align-itmes-center">
												<div className="subject_img_wrap d-flex align-items-center">
													<figure className="subject_img">
														<img src={Icons.Micro} alt="" className="img-fluid" />
													</figure>
													<div className="subject_details">
														<h6>Microbiology</h6>
														<p>Dr.Ashwani Kumar</p>
													</div>
												</div>	
											</div>
										</a>
									</li>
								</ul>
							</div>
						</div>
					</div> */}
							</div>
						</section>
					}
				</div>
			}

			<div>

			</div>
			<ToastContainer />
			<Modal
				show={infoShow}
				onHide={infoDetailhide}
				backdrop="static"
				className="detail_modal report_modal"
				centered
			>
				<form action="" onSubmit={(e) => { handleSubmit(e) }}>
					<Modal.Header>
						<Modal.Title>
							<h4>Report Issue</h4>
							<span className="cross_icon">
								<img src={Icons.ModalCross} alt="" className="img-fluid" onClick={infoDetailhide} />
							</span>
						</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<div className="rating_modal_body">
							<div className="form-group">
								<label htmlFor="">Issue Type</label>
								<select name="" id="" className="form-control" onChange={(e) => handleInputChange(e.target.value, 'category')} value={getDetails.category ?? ''}>
									<option value=''>Please Select</option>
									{
										config && config?.qb_question?.categories?.map((d, i) => (
											<option value={d.category_name}>{d.category_name}</option>
										))
									}
								</select>
							</div>
							<div className="form-group">
								<label htmlFor="">Description</label>
								<textarea name="" id="" rows="5" className="form-control" placeholder="Please add issue description here..." onChange={(e) => handleInputChange(e.target.value, 'userFeedBack')} value={getDetails.userFeedBack ?? ''}></textarea>
							</div>
						</div>
					</Modal.Body>
					<Modal.Footer>
						<div className="rating_submit">
							<button type="button" className="btn btn_theme btn_border" onClick={infoDetailhide}>Cancel</button>
							<button type="submit" disabled={enable} className="btn btn_theme" >Submit</button>
						</div>
					</Modal.Footer>
				</form>
			</Modal>

		</>


	)
}